import React from 'react';
import { MdClose, MdAdd, MdRemove } from 'react-icons/md'
import { Button } from 'reactstrap'
import { MAX_ALLOWED_REF_PUNKTE } from '../../EivngCore'

/**
 * Zaehler fuer die Ref/Mod/WL-Punkte.
 *
 * Vorher standen hier zwei Pfeilringe (hoch/runter) nebeneinander - senkrechte Pfeile in
 * waagerechter Anordnung, dazu der Wert 0 als "-" direkt neben dem Verringern-Pfeil. Jetzt
 * minus links, plus rechts, und die Null steht als Null da.
 *
 * Die Knoepfe sind echte Buttons, keine angeklickten Icons: nur so gibt es Tastaturbedienung,
 * eine Trefferflaeche fuer den Finger am Einlass und einen sichtbaren Aus-Zustand an den
 * Grenzen. Vorher liefen Klicks an den Grenzen ins Leere, ohne dass man dem Steuerelement
 * ansah, dass 0 bzw. das Maximum erreicht war.
 *
 * onMouseDown wird unterdrueckt, damit der Fokus im EFN-Eingabefeld bleibt - ein Handscanner
 * schiesst seine Ziffern sonst ins Nichts.
 */
const ReferentenPunkteComponent = (props) => {
	const notBoundedFunction = () => console.log("function not bounded");
	const { punkte = 0, decreasePunkte = notBoundedFunction, increasePunkte = notBoundedFunction, setPunkte = notBoundedFunction} = props;
	// text-bg-* setzt Flaeche UND Schrift. In Bootstrap 5 faerbt bg-* allein nur die
	// Flaeche, .badge schreibt weiss - auf Gelb oder Hellgrau ist das nicht lesbar.
	// Der Nullwert nimmt die Koerperfarben, damit er im Dunkelmodus mitwandert.
	const referentPunkteClass = punkte === 0 ? "bg-body-secondary text-body"
		: punkte === 1 ? "text-bg-info"
		: punkte < 3 ? "text-bg-warning" : "text-bg-danger"
	const amMinimum = punkte <= 0;
	const amMaximum = punkte >= MAX_ALLOWED_REF_PUNKTE;
	const titelPlus = amMaximum ? `mehr als ${MAX_ALLOWED_REF_PUNKTE} Punkte sind nicht möglich` : "ein Punkt mehr";
	return(
				<span className="d-inline-flex align-items-center gap-1" onMouseDown={(e) => e.preventDefault()}>
					<Button color="secondary" outline size="sm" className="px-2" disabled={amMinimum}
						title="ein Punkt weniger" aria-label="ein Punkt weniger"
						onClick={() => decreasePunkte()}>
						<MdRemove fontSize="1.1em" />
					</Button>
					{/* Feste Mindestbreite, damit der Sprung von 9 auf 10 die Knoepfe nicht unter
					    dem Finger verschiebt. aria-live, weil sich beim Tippen nur diese Zahl aendert. */}
					<strong><span className={"badge text-center " + referentPunkteClass} style={{fontSize: "100%", minWidth: "2.7em"}}
						aria-live="polite">{punkte}</span></strong>
					<Button color="secondary" outline size="sm" className="px-2" disabled={amMaximum}
						title={titelPlus} aria-label="ein Punkt mehr"
						onClick={() => increasePunkte()}>
						<MdAdd fontSize="1.1em" />
					</Button>
					{/* Erst ab 2 Punkten: bei genau einem ist das Minus links der kuerzere Weg, und
					    ein Knopf weniger heisst ein Fehlgriff weniger neben "Entfernen" in derselben
					    Zeile. */}
					{ punkte > 1 &&
						<Button color="link" size="sm" className="px-1 text-body-secondary"
							title="Punkte zurücksetzen" aria-label="Punkte zurücksetzen"
							onClick={() => setPunkte(0)}>
							<MdClose fontSize="1.1em" />
						</Button>
					}
				</span>

	)
}
export default ReferentenPunkteComponent
